<template>
    <div class="summary-page" :class="{'loading':loadingNow || renderingNow}">
        <h3>Summary</h3>
        <form>
            <div class="activePlaceholderImitation">
                <datepicker
                    v-model="filters.immediate.startDate"
                    calendar-class='calendar'
                    :disabled-dates="{from: new Date(filters.immediate.endDate)}"
                    :use-utc='true'
                ></datepicker>
                <span>Start date</span>
            </div>

            <div class="activePlaceholderImitation">
                <datepicker
                    v-model="filters.immediate.endDate"
                    calendar-class='calendar'
                    :disabled-dates="{to: new Date(filters.immediate.startDate)}"
                    :use-utc='true'
                ></datepicker>
                <span>End date</span>
            </div>

            <div class="plusMinusDay">
                <div class="minus" @click="changeDay('subtract')">
                    <div></div>
                </div>
                <div class="plus" @click="changeDay('add')">
                    <div></div>
                </div>
                <span>Days</span>
            </div>

            <div class="selectWrapper activePlaceholder" :class="{'selected':filters.immediate.timeframe}">
                <v-select 
                    v-model="filters.immediate.timeframe" 
                    :options="timeframeList"
                    :reduce="obj => obj.code" >
                </v-select>
                <span>Timeframe</span>
            </div>
        
            <div class="amount">
                <div class="moreLess">
                <div class="less" :class="{'active':!moreSelected}" @click="moreSelected = false; getData()">
                    <img src="../../assets/img/more.svg" alt="">
                </div>
                <div class="more" :class="{'active':moreSelected}" @click="moreSelected = true; getData()">
                    <img src="../../assets/img/more.svg" alt="">
                </div>
                </div>
                <div class="activePlaceholder">
                    <input type="number" placeholder=" " v-model="filters.throttle.more_than_usd">
                    <span>Amount USD</span>
                </div>
            </div>

            <div class="threeButtons">
                <div :class="{'active' : transactionsSize == 'All'}" @click="handeTransactionsSize('All')">All</div>
                <div :class="{'active' : transactionsSize == 'Small'}" @click="handeTransactionsSize('Small')">Small</div>
                <div :class="{'active' : transactionsSize == 'Large'}" @click="handeTransactionsSize('Large')">Large</div>
            </div>

            <div class="refresh" @click="getData"></div>
        </form>

        <div class="flex f-wrap">
            <div class="table-summary-container">
                <table class="table-summary table">
                    <thead>
                        <tr>
                            <th v-for="item in tableSummary" :key="item"> {{item}} </th>
                        </tr>
                    </thead>
                    <tbody v-if="summaryTableRows.length">
                        <tr v-for="item in summaryTableRows" :key="item.id">
                            <td>{{item.token}}</td>
                            <td class="text-right">{{addCommas(item.inbound)}}</td>
                            <td class="text-right">{{addCommas(item.outbound)}}</td>
                            <td class="text-right green" :class="{'red':item.difference < 0}">{{addCommas(item.difference)}}</td>
                            <td class="text-center">
                                <span class="bear" v-if="item.signal === 'BEAR'"> <img src="../../assets/img/bear.svg" alt=""> BEAR </span>
                                <span class="bull" v-if="item.signal === 'BULL'"> <img src="../../assets/img/bull.svg" alt=""> BULL </span>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else >
                        <tr>
                            <td colspan="14" class="text-center">
                                {{this.queryError ? this.queryError : 'No data, please check your filters'}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <table class="table-total table">
                <thead>
                    <tr>
                        <th v-for="item in tableTotal" :key="item"> {{item}} </th>
                    </tr>
                </thead>
                <tbody v-if="totalTableRows.length">
                    <tr v-for="item in totalTableRows" :key="item.id">
                        <td class="text-right">{{addCommas(item.bullish)}}</td>
                        <td class="text-right">{{addCommas(item.bearish)}}</td>
                        <td class="text-right green" :class="{'red':item.difference < 0}">{{addCommas(item.difference)}}</td>
                    </tr>
                </tbody>
                <tbody v-else >
                    <tr>
                        <td colspan="14" class="text-center">
                            {{this.queryError ? this.queryError : 'No data, please check your filters'}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="table-timeframes-container">
            <table class="table-timeframes table">
                <thead>
                    <tr>
                        <th v-for="item in tableTimeframes" :key="item"> {{item}} </th>
                    </tr>
                </thead>
                <tbody v-if="timeframesTableRows.length">
                    <tr v-for="item in timeframesTableRows" :key="item.id">
                        <td>{{item.time}}</td>
                        <td>{{item.token}}</td>
                        <td class="text-right">{{addCommas(item.inbound)}}</td>
                        <td class="text-right">{{addCommas(item.outbound)}}</td>
                        <td class="text-right green" :class="{'red':item.difference < 0}">{{addCommas(item.difference)}}</td>
                        <td class="text-center">
                            <span class="bear" v-if="item.signal === 'BEAR'"> <img src="../../assets/img/bear.svg" alt=""> BEAR </span>
                            <span class="bull" v-if="item.signal === 'BULL'"> <img src="../../assets/img/bull.svg" alt=""> BULL </span>
                        </td>
                        <td class="text-right">{{addCommasDecimal(item.OHLC.open)}}</td>
                        <td class="text-right">{{addCommasDecimal(item.OHLC.high)}}</td>
                        <td class="text-right">{{addCommasDecimal(item.OHLC.low)}}</td>
                        <td class="text-right">{{addCommasDecimal(item.OHLC.close)}}</td>
                        <td class="text-right">{{addCommasDecimal(item.OHLC.avg)}}</td>
                    </tr>
                </tbody>
                <tbody v-else >
                    <tr>
                        <td colspan="14" class="text-center">
                        {{this.queryError ? this.queryError : 'No data, please check your filters'}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import _ from 'lodash'

export default {
    name: 'Summary',
    components: {
        Datepicker
    },
    data: () => ({
        loadingNow:false,
        renderingNow:false,
        moreSelected:true,
        transactionsSize:'Large',
        filters:{
            immediate:{
                startDate: new Date().toUTCString(),
                endDate: new Date().toUTCString(),
                timeframe:'1h'
            },
            throttle:{
                more_than_usd:'950000'
            }
        },
        tableSummary:['Token','Inbound','Outbound','Difference','Signal'],
        tableTotal:['Bullish','Bearish','Difference'],
        tableTimeframes:['Timeframe','Token','Inbound','Outbound','Difference','Signal','Open','High','Low','Close','VWAP'],
        responseData:null
    }),
    watch:{
        // send immediate query
        filtersImmediate: {
            handler(){
                this.getData();
            },
            deep: true
        },
        // send query if user doesn't type 500ms
        filtersThrottle: {
            handler: _.debounce(function(){
                this.getData();
                }, 500),
            deep: true
        },
    },
    computed:{
        filtersImmediate(){
            return this.filters.immediate;
        },
        filtersThrottle(){
            return this.filters.throttle;
        },
        summaryTableRows(){
            return (this.responseData && !this.responseData.error) ? this.responseData.general.summary.slice(0,-1) : [];
        },
        totalTableRows(){
            return (this.responseData && !this.responseData.error) ? this.responseData.general.summary.slice(-1) : [];
        },
        timeframesTableRows(){
            return (this.responseData && !this.responseData.error) ? this.responseData.timeframes.slice().reverse() : [];
        },
        queryError(){
            return this.responseData ? this.responseData.error : '';
        },
        timeframeList(){
            let fullTimeframeList = [
                {label: 'Hourly', code: '1h'},
                {label: 'Daily', code: '1d'},
                {label: 'Weekly', code: '1w'},
                {label: 'Monthly', code: '1m'},
            ];
            let daysDiference = this.getDaysDifference(this.filters.immediate.startDate, this.filters.immediate.endDate);
            if (daysDiference < 7){
                return fullTimeframeList.slice(0,-2);
            }
            else if(daysDiference >= 7 && daysDiference <= 30){
                return fullTimeframeList.slice(0,-1);
            }
            else{
                return fullTimeframeList;
            }
        }
    },
    methods:{
        changeDay(action){
            // if it's not future day
            if (moment(this.filters.immediate.startDate)[action](1,'days').utc().toDate() <= moment(new Date()).utc().toDate()){
                this.filters.immediate.startDate = moment(this.filters.immediate.startDate)[action](1,'days').utc().toDate().toUTCString();
                this.filters.immediate.endDate = moment(this.filters.immediate.endDate)[action](1,'days').utc().toDate().toUTCString();
            }
        },
        handeTransactionsSize(size){
            this.transactionsSize = size;
            let usdValue = '';
            switch(size){
                case 'All': usdValue = '';  break;
                case 'Small': usdValue = '950000'; this.moreSelected = false;  break;
                case 'Large': usdValue = '950000'; this.moreSelected = true; break;
            }
            if (this.filters.throttle.more_than_usd != usdValue){
                this.filters.throttle.more_than_usd = usdValue;
            }
            else{
                this.getData();
            }
        },
        getData(page = 1){
            // check dates params
            let daysDiference = this.getDaysDifference(this.filters.immediate.startDate, this.filters.immediate.endDate);
            if (daysDiference < 7){
                if (this.filters.immediate.timeframe == '1w' || this.filters.immediate.timeframe == '1m'){
                    this.filters.immediate.timeframe = '1d';
                    return;
                }
            }
            else if(daysDiference >= 7 && daysDiference <= 30){
                if (this.filters.immediate.timeframe == '1m'){
                    this.filters.immediate.timeframe = '1w';
                    return;
                }
            }

            // create object with all required params
            let queryParameters = {
                params:{
                    page:page,
                    startDate:moment(this.filters.immediate['startDate']).utc().format('YYYY-MM-DD'),
                    endDate:moment(this.filters.immediate['endDate']).utc().format('YYYY-MM-DD'),
                    timeframe:this.filters.immediate['timeframe'].toLowerCase(),
                }
            };

            if(this.filters.throttle['more_than_usd']){
                if (this.filters.throttle['more_than_usd'].length < 6) return;

                if (this.moreSelected){
                    queryParameters.params['more_than_usd'] = this.filters.throttle['more_than_usd'];
                }
                else{
                    queryParameters.params['less_than_usd'] = this.filters.throttle['more_than_usd'];
                }
            }
            this.loadingNow = true;
            axios.get('tx/summary',queryParameters).then(response => {
                this.responseData = response.data;
                this.renderingNow = true;
                this.loadingNow = false;
            });
        },
    },
    created(){
        this.getData();
    },
    updated(){
        this.renderingNow = false;
    }
}
</script>>
<style lang="scss" scoped>
.summary-page{
    form{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        max-width: 1110px;
        @media (max-width: 1160px) {
            justify-content: flex-start;
        }
        & > *:not(.threeButtons){
        width: 168px;
        margin-bottom: 20px;
            @media (max-width: 1160px) {
                margin-right: 10px;
                &.activePlaceholderImitation,
                &.plusMinusDay,
                &.refresh{
                    order: -1;
                }
                &:nth-child(7){
                    margin-right: calc(100% - 480px);
                }
            }
            @media (max-width: 530px) {
                width: 100%;
                margin-right: 0px !important;
                &.plusMinusDay{
                    margin-right: 15px !important;
                }
            }
        }
        .threeButtons{
        margin-bottom: 20px;
        }
  }
  .table-summary,
  .table-total{
      position: relative;
      border-collapse: collapse;
      th:not(:last-child){
          border-right: 2px solid var(--main-bg-color);
      }
      td{
          padding: 6px 3px;
      }
  }
  .table-summary-container{
        width: 50%;
        margin-right: 20px;

        @media (max-width: 800px) {
            width: 100%;
            margin-bottom: 20px;
            margin-right: 0px;
        }
        @media (max-width: 600px) {
            overflow-y: hidden;
            overflow-x: scroll;
        }

    .table-summary{
        width: 100%;
        @media (max-width: 800px) {
            min-width: 500px;
        }
    }
  }
  .table-total{
        width: 27%;
        @media (max-width: 800px) {
            width: 60%;
            min-width: 280px;
        }
  }
  .table-timeframes-container{
        position: relative;

        @media (max-width: 950px) {
            overflow-y: hidden;
            overflow-x: scroll;
        }
    .table-timeframes{
            width: 100%;
            min-width: 900px;
            margin-top: 20px;
            thead {
                display: table; 
                width: 100%;
            }
            tbody{
                display: block; 
                max-height: calc(100vh - 83px - 315px);
                overflow-y: scroll;
                tr {
                    display: table;
                    width: 100%;
                }
            }
            th,td{
                max-width: 80px;
                &:nth-child(1){
                    width: 10%;
                }
                &:nth-child(2){
                    width: 6%;
                }
                &:nth-child(3){
                    width: 8%;
                }
                &:nth-child(4){
                    width: 8%;
                }
                &:nth-child(5){
                    width: 7%;
                }
                &:nth-child(6){
                    width: 7%;
                }
                &:nth-child(7){
                    width: 7%;
                }
                &:nth-child(8){
                    width: 7%;
                }
                &:nth-child(9){
                    width: 7%;
                }
                &:nth-child(10){
                    width: 7%;
                }
                &:nth-child(11){
                    width: 7%;
                }
                }
                td{
                &:nth-child(11){
                    width: 6%;
                }
            }
    }
  }
    td {
        span{
            img{
                vertical-align: bottom;
            }
            &.bull{
                color: #AB0029;
            }
            &.bear{
                color: #75491A;
            }
        }
        &.green{
            color: #0EAB69;
        }
        &.red{
            color: #AB0029 !important;
        }
    }
    &.loading{
        pointer-events: none;
        table:before{
            content: "";
            width: 500%;
            height: 100%;
            position: absolute;
            z-index: 5;
            background: var(--loading-bg);
            top:0;
        }
        .table-timeframes-container:after{
            content: "";
            width: 64px;
            height: 64px;
            background: url('../../assets/img/loader.svg') no-repeat;;
            position: absolute;
            z-index: 10;
            left:50%;
            top:50%;
            transform: translate(-50%,-50%);
        }
    }
}
</style>